import React, { useEffect, useState } from "react";
import { Api } from "../../../api";
import axios from "axios";
import { Headers } from "../../../api/actions";
import Loading from "../../../components/loading/loading";
import { useParams } from "react-router";

import NavbarLeft from "../../../components/navbar/navbar_left";
import NavbarTop from "../../../components/navbar/navbar_top";
import MaterialsSubjectContent from "../component/material-subject";
import axiosInstance from "../../../api/axios_instance";

const MaterialSubject = () => {
  const { page, search, subjectId, classroomId, classroomNumber } = useParams();
  const pageCount = +page.slice(page.indexOf(":") + 1, page.length);
  const searchKeyword = search.slice(search.indexOf(":") + 1, search.length);
  const sortSubject = subjectId.slice(
    subjectId.indexOf(":") + 1,
    subjectId.length
  );
  const sortClassRoom = classroomId.slice(
    classroomId.indexOf(":") + 1,
    classroomId.length
  );
  const sortclassroomNumber = classroomNumber.slice(
    classroomNumber.indexOf(":") + 1,
    classroomNumber.length
  );
  const [perpage, setPerpage] = useState(0);
  const [PageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetData(
      setData,
      setLoading,
      pageCount,
      searchKeyword,
      sortSubject,
      sortClassRoom,
      sortclassroomNumber,
      PageSize,
      setPerpage
    );
  }, [
    pageCount,
    searchKeyword,
    sortSubject,
    sortClassRoom,
    sortclassroomNumber,
    PageSize,
  ]);

  const ObJectArrayData = [
    {
      id: 2,
      href: `/materials/page:${1}/search:${""}/sortclassroom:${""}`,
      title: "المواد التعليمية",
    },
  ];
  if (!loading) {
    return (
      <section className="main">
        <NavbarLeft />
        <div className="main-body">
          <NavbarTop ArrayData={ObJectArrayData} />
          <div className="main-body__content">
            <Loading />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="main">
      <NavbarLeft />
      <div className="main-body">
        <NavbarTop ArrayData={ObJectArrayData} />
        <div className="main-body__content">
          <MaterialsSubjectContent
            ArrayData={data}
            perpage={perpage}
            pagenumber={pageCount}
            setLoading={setLoading}
            PageSize={PageSize}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </section>
  );
};

export default MaterialSubject;

const GetData = async (
  setData,
  setLoading,
  pageCount,
  searchKeyword,
  sortSubject,
  sortClassRoom,
  sortclassroomNumber,
  PageSize,
  setPerpage
) => {
  var data = new FormData();
  data.append("pageNumber", pageCount);
  data.append("searchKeyword", searchKeyword);
  data.append("classRoomId", sortClassRoom);
  data.append("subjectId", sortSubject);
  data.append("pageSize", PageSize);
  data.append("classRoomNumber", sortclassroomNumber);

  const options = {
    method: "post",
    url: `${Api}Test/GetSubjectTests_Students`,
    headers: Headers,
    data,
  };
  await axiosInstance(options)
    .then(function (response) {
      setData(response.data.responseObject.items);
      setLoading(true);

      setPerpage(
        Math.ceil(
          response.data.responseObject.totalItemsCount /
            response.data.responseObject.pageSize
        )
      );
    })
    .catch(function (error) {
      setLoading(true);
    });
};
